import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./PersonaManager.css";
import { PersonaCard } from "./PersonaCard";
import { AttributeType, PersonaExpanded } from "winslow-core";
import {
  apiGetPersonas,
  apiGetEmployeeAttributes,
} from "../../services/PersonasService";
import { selectUser } from "../../redux/features/appData";

import { PersonaCreator } from "./PersonaCreator";

export default function PersonaManager() {
  const storeUser = useSelector(selectUser);

  const [personas, setPersonas] = useState<PersonaExpanded[]>([]);

  const [isCreatorOpen, setIsCreatorOpen] = useState(false);

  const [selectedPersona, setSelectedPersona] =
    useState<PersonaExpanded | null>(null);

  const [employeeAttributes, setEmployeeAttributes] = useState<Record<
    AttributeType,
    string[]
  > | null>(null);

  const handlePersonaClick = (persona: PersonaExpanded) => {
    setSelectedPersona(persona);
    setIsCreatorOpen(true);
  };

  const refreshPersonas = () => {
    if (storeUser && storeUser.currentWorkspaceId) {
      apiGetPersonas(storeUser.currentWorkspaceId).then((personaResults) => {
        if (personaResults) {
          setPersonas(personaResults);
        }
      });

      apiGetEmployeeAttributes(storeUser.currentWorkspaceId).then(
        (employeeAttributesResults) => {
          if (employeeAttributesResults) {
            setEmployeeAttributes(employeeAttributesResults);
          }
        }
      );
    }
  };

  const handleCreatorClose = () => {
    setIsCreatorOpen(false);
    setSelectedPersona(null);
  };

  useEffect(() => {
    refreshPersonas();
  }, [storeUser]);

  return (
    <div className="persona-manager-container">
      <div className="persona-manager-header">
        <h1 className="persona-manager-title">Manage Personas</h1>
        <button
          className="persona-manager-new-button"
          onClick={() => {
            setSelectedPersona(null);
            setIsCreatorOpen(true);
          }}>
          + New Persona
        </button>
      </div>
      <div className="persona-manager-cards-container">
        <div className="persona-manager-card-grid">
          {personas.map((persona) => (
            <div key={persona.id} className="persona-manager-card-column">
              <PersonaCard onClick={handlePersonaClick} persona={persona} />
            </div>
          ))}
        </div>
      </div>
      <PersonaCreator
        isOpen={isCreatorOpen}
        onClose={handleCreatorClose}
        existingPersona={selectedPersona}
        onPersonaSaved={refreshPersonas}
        employeeAttributes={employeeAttributes}
      />
    </div>
  );
}
